import { Col, Row } from "antd";
import React from "react";
import phonesvg from "src/shared/assets/svg/icon/phone.svg";
import whatsappsvg from "src/shared/assets/svg/icon/whatsapp.svg";
import { ButtonC } from "src/shared/components";
import useDomain from "src/shared/hooks/useDomain";
import "./index.less";

const FooterWhiteLable = () => {
  const { name, supportPhone, whatsapp } = useDomain();
  return (
    <Row gutter={[0, 20]}>
      <Col
        span={24}
        style={{ padding: "10px 0", background: "#F5F5F5", height: "133px" }}
      >
        <Row gutter={[0, 10]} justify="center" style={{ padding: "10px 0" }}>
          <Col style={{ margin: "0 50px" }}>
            <img style={{ margin: "0 8px" }} src={phonesvg} alt="" />
            <span>
              <span>تماس با پشتیبانی {name} : </span>
              {supportPhone?.map((item: any) => (
                <span style={{ direction: "ltr", textAlign: "left" }}>
                  {item}
                  {supportPhone?.length > 1 && <span> - </span>}
                </span>
              ))}
            </span>
          </Col>
          <Col style={{ margin: "0 50px" }}>
            {/* <ButtonC> */}
            <a
              href={`https://api.whatsapp.com/send/?text=سلام وقت بخیر&phone=${whatsapp}`}
              style={{ color: "#555" }}
              target="_blank"
            >
              <img style={{ margin: "0 8px" }} src={whatsappsvg} alt="" />
              <span>ارتباط مستقیم در واتس اپ</span>
            </a>
            {/* </ButtonC> */}
          </Col>
        </Row>
      </Col>
      <Col style={{ textAlign: "center" }} span={24}>
        <span>کلیه حقوق این سایت متعلق به {name} می باشد</span>
      </Col>
    </Row>
  );
};

export default FooterWhiteLable;
